import { useState } from 'react'
import Link from 'next/link'
import { MenuAlt4Icon, XIcon } from '@heroicons/react/solid'
import Logo from '../Logo'

export default function Header() {
  const [mobileMenuActive, setMobileMenuActive] = useState(false)

  return (
    <div className="relative flex bg-terminal py-5">
      <div className="container mx-auto px-8">
        <div className="flex justify-between space-x-8">
          <Link href="/demo" passHref className="flex" title="Covie demo">

            <Logo />

          </Link>

          <div>
            {/* Mobile menu trigger */}
            <button
              type="button"
              className="flex text-white  md:hidden"
              onClick={() => setMobileMenuActive(!mobileMenuActive)}
            >
              {mobileMenuActive ? (
                <XIcon className="h-8 w-8" />
              ) : (
                <MenuAlt4Icon className="h-8 w-8" />
              )}
            </button>

            {/* Desktop Menu */}
            <div className="hidden items-center space-x-12 md:flex">
              <Link href="/demo" passHref className="py-4 text-lg text-white">
                Demo
              </Link>
              <a
                target="_blank"
                href="https://developer.covie.com/"
                rel="noreferrer"
                className="py-4 text-lg text-white"
              >
                Documentation
              </a>
              <a
                target="_blank"
                href="https://www.covie.io/request"
                rel="noreferrer"
                className="py-4 text-lg text-white"
              >
                Get access
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      {mobileMenuActive && (
        <div className="absolute left-0 top-100 z-30 flex w-full p-6">
          <div className="flex w-full flex-col rounded-lg border bg-white py-4 shadow-lg">
            <Link href="/demo" passHref className="px-8 py-4 text-lg text-gray-800">
              Demo
            </Link>
            <a
              target="_blank"
              href="https://developer.covie.com/"
              rel="noreferrer"
              className="px-8 py-4 text-lg text-gray-800"
            >
              Documentation
            </a>
            <a
              target="_blank"
              href="https://www.covie.io/request"
              rel="noreferrer"
              className="px-8 py-4 text-lg text-gray-800"
            >
              Get access
            </a>
          </div>
        </div>
      )}
    </div>
  );
}
